
import { computed, defineComponent } from "vue";

import coachmarkTailImage from "../../assets/coachmark/tail.png";
import { CCard, COverlay } from "../../vuetify-components";

export default defineComponent({
  components: { CCard, COverlay },
  props: {
    text: {
      type: String,
      required: true,
    },
    top: {
      type: String,
      default: undefined,
    },
    bottom: {
      type: String,
      default: undefined,
    },
    tailTop: {
      type: String,
      default: undefined,
    },
    tailBottom: {
      type: String,
      default: undefined,
    },
    tailLeft: {
      type: String,
      default: undefined,
    },
    tailRight: {
      type: String,
      default: undefined,
    },
    tailPointUp: {
      type: Boolean,
      default: undefined,
    },
    tailPointDown: {
      type: Boolean,
      default: undefined,
    },
  },
  emits: {
    "on-overlay-click": () => true,
  },
  setup(props, { emit }) {
    const coachmarkBodyVars = computed(() => {
      return {
        "--coachmark--top": props.top,
        "--coachmark--bottom": props.bottom,
      };
    });

    const coachmarkTailVars = computed(() => {
      return {
        "--coachmark-tail--top": props.tailTop,
        "--coachmark-tail--bottom": props.tailBottom,
        "--coachmark-tail--left": props.tailLeft,
        "--coachmark-tail--right": props.tailRight,
        "--coachmark-tail--direction": props.tailPointUp
          ? "rotate(0deg)"
          : props.tailPointDown
          ? "rotate(180deg)"
          : undefined,
      };
    });

    const handleClick = () => {
      emit("on-overlay-click");
    };

    return { coachmarkTailImage, coachmarkBodyVars, coachmarkTailVars, handleClick };
  },
});
